import { useLayoutEffect } from 'react'

type ScrollLock = { users: number; restore: () => void }
const locks = new Map<HTMLElement, ScrollLock>()

export function isPageScrollLocked() {
  return locks.size > 0
}

// The cabinet scrolls its main element, not body. Leave modal content scrollable,
// and keep each background element locked until its last modal has closed.
export function usePageScrollLock(open: boolean) {
  useLayoutEffect(() => {
    if (!open) return

    const elements = [document.documentElement, document.body, ...document.querySelectorAll<HTMLElement>('.app-layout__scroller')]
    for (const element of elements) {
      const existing = locks.get(element)
      if (existing) {
        existing.users += 1
        continue
      }
      const properties = ['overflow', 'overflow-x', 'overflow-y', 'overscroll-behavior']
      const previous = properties.map((property) => [property, element.style.getPropertyValue(property), element.style.getPropertyPriority(property)])
      element.style.setProperty('overflow', 'hidden')
      element.style.setProperty('overscroll-behavior', 'none')
      locks.set(element, {
        users: 1,
        restore: () => {
          for (const [property, value, priority] of previous) {
            if (value) element.style.setProperty(property, value, priority)
            else element.style.removeProperty(property)
          }
        },
      })
    }

    return () => {
      for (const element of elements) {
        const lock = locks.get(element)!
        lock.users -= 1
        if (lock.users === 0) {
          lock.restore()
          locks.delete(element)
        }
      }
    }
  }, [open])
}
